import {
    IonAlert, IonCol, IonContent, IonGrid, IonicSafeString, IonPage, IonRow,
    IonButton, IonIcon
} from '@ionic/react';
import React, { useState, ComponentProps } from 'react';
import { useDispatch, useSelector} from 'react-redux';
import useMopHooks from '../helpers/useMopHook';
import { ApplicationState } from '../store';
import { SimpleChannel, simpleChannelType } from '../store/LocationStore';
import * as BasketStore from '../store/BasketStore';
import './ChooseOrderType.scss';
import { bindActionCreators } from 'redux';
import { baseUrl } from '../helpers/configHelper';
import Button from '../components/Button';
import {WaitTimesBanner} from "../components/wait-times/WaitTimesBanner";
import {useWaitTimes} from "../helpers/waitTimesHelper";

// TODO: Move to global?
type Dictionary<Key extends keyof any, Value> = {
    [key in Key]: Value;
}

interface IChannelProps {
    title: string
    icon: string
}

const channelProps: Dictionary<simpleChannelType, IChannelProps | null> = {
    TableOrder: {
        title: "Eat In",
        icon: `${baseUrl()}/images/assets/eat_in_icon.svg`
    },

    ClickAndCollect: {
        title: "Take Away",
        icon: `${baseUrl()}/images/assets/take_away_icon.svg`
    },

    KerbsideOrder: null,
};

function ChannelButton(props: IChannelProps & ComponentProps<typeof IonButton>) {
    return (
        <Button expand="block" color="light" onClick={props.onClick}>
            <IonIcon slot="start" src={props.icon} color="primary"></IonIcon>
            {props.title}
        </Button>
    )
}

const ChooseOrderType: React.FC = () => {
    const { onChannelSelected } = useMopHooks();
    const [selectedChannel, setSelectedChannel] = useState() as any;
    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [isClearBasketAlertOpen, setClearBasketAlertOpen] = useState(false);
    const LocationState = useSelector((state: ApplicationState) => state.location);
    const BasketState = useSelector((state: ApplicationState) => state.basket);
    const boundClearBasket = bindActionCreators(BasketStore.actionCreators.clearBasket, useDispatch());
    const { displayWaitTimes } = useWaitTimes();

    const handleOrderTypeClick = (channel: SimpleChannel) => {
        if (channel == null) {
            return;
        }

        if (LocationState?.selectedChannel !== undefined && LocationState.selectedChannel.channelType !== channel.channelType && BasketState && BasketState.basket.menuItems.length > 0) {
            setSelectedChannel(channel);
            setClearBasketAlertOpen(true);
            return;
        }

        switch (channel.channelType) {
            case simpleChannelType.ClickAndCollect:  {
                onChannelSelected(channel)
                break;
            }

            case simpleChannelType.TableOrder:  {
                if (localStorage.getItem('isLoggedIn') === "true") {
                    // Colleague logged in so bypass the alert dialog
                    onChannelSelected(channel);
                } else {
                    setIsAlertOpen(true);
                    setSelectedChannel(channel);
                }

                break;
            }
        }
    }

    return (
        <IonPage>
            <IonContent
                className="order-type"
                style={{
                    "--background": `no-repeat url(${baseUrl()}/images/assets/order_type_bg_END.png) top/cover`,
                }}>
                <IonAlert
                    backdropDismiss={false}
                    isOpen={isAlertOpen}
                    onDidDismiss={() => {
                        setIsAlertOpen(false);
                        onChannelSelected(selectedChannel);
                    }}
                    header={"Eat In"}
                    buttons={[
                        {
                            text: "I understand",
                            role: "cancel"
                        }
                    ]}
                    message='Hot food will be delivered to your table, please pick up your counter items such as sandwiches and hot drinks.'
                />
                <IonAlert
                    isOpen={isClearBasketAlertOpen}
                    onDidDismiss={() => {
                        setClearBasketAlertOpen(false);
                    }}
                    header={"Are you sure?"}
                    buttons={[
                        {
                            text: "Cancel",
                            role: "cancel"
                        },
                        {
                            text: "Clear basket",
                            handler: () => {
                                boundClearBasket();
                                onChannelSelected(selectedChannel);
                            }
                        }
                    ]}
                    message="Changing your order type will clear the items in your basket, are you sure you want to continue?"
                />

                <IonGrid className="card">
                    <img
                        src={`${baseUrl()}/images/assets/Logo_MC.png`}
                        alt="Morrisons Cafe logo"
                        className="morrisons-logo"
                    />
                    <IonRow>
                        <IonCol>
                            <p>Welcome to</p>
                            <p>Morrisons Café {LocationState?.selectedStore?.storeName}</p>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol style={{
                                margin: "1rem 0 1rem 0"
                            }}
                        >
                            <p><strong>Tap an option to get started</strong></p>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        {LocationState?.selectedStore?.supportedChannels
                            .sort((a, b) => {
                                const aTitle = channelProps[a.channelType]?.title ?? "";
                                const bTitle = channelProps[b.channelType]?.title ?? "";

                                return aTitle < bTitle ? -1 : 1;
                            })
                            .map((channel, i) => {
                                console.log(channel, i);
                                const channelType = channel.channelType;
                                const props = channelProps[channelType];

                                if (props === null) {
                                    return false;
                                }

                                return (
                                    <IonCol size="12">
                                        <ChannelButton
                                            key={"orderType__" + channel.channelType}
                                            disabled={!channel.enabled}
                                            onClick={() => { handleOrderTypeClick(channel) }}
                                            {...props}
                                        />
                                    </IonCol>
                                )
                            })
                        }
                    </IonRow>
                </IonGrid>
                {displayWaitTimes && <WaitTimesBanner />}
            </IonContent>
        </IonPage>
    )
}

export default ChooseOrderType;
